export default "__VITE_ASSET__db8a370b__"